import "./CookieNotice.scss";

export const CookieNotice = (props: {
  onOK: () => void;
  onCancel: () => void;
}): JSX.Element => {
  const onOK = () => {
    props.onOK();
  };

  const onCancel = () => {
    props.onCancel();
  };

  return (
    <div className="cookieNotice">
      <p>This website uses cookies to ensure you get the best experience on our website.</p>
      <div className="buttons">
        <button className="ok button" onClick={onOK}>Got it!</button>
        <button className="cancel button" onClick={onCancel}>Decline</button>
      </div>
    </div>
  );
};
